import { render, staticRenderFns } from "./TableSummary.vue?vue&type=template&id=15c044c1&scoped=true&"
import script from "./TableSummary.vue?vue&type=script&lang=js&"
export * from "./TableSummary.vue?vue&type=script&lang=js&"
import style0 from "./TableSummary.vue?vue&type=style&index=0&id=15c044c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c044c1",
  null
  
)

export default component.exports